import { locationsManagementApi } from '@/api';
import { sectorsList, laboratories } from '@/config/constants';
import { filterOptions } from '@/config/enumOptions';

const availableLaboratories = [
  { value: laboratories.CHIM, label: 'enums.laboratories.CHIM' },
  { value: laboratories.MICR, label: 'enums.laboratories.MICR' },
];

const sectorsAssociationFilters = [
  {
    name: 'sector',
    label: 'sector',
    type: 'select',
    whereOperator: '=',
    options: filterOptions(sectorsList, 'enums.sectors'),
  },
  {
    name: 'department',
    label: 'department',
    type: 'select',
    whereOperator: '=',
    options: availableLaboratories,
  },
  {
    name: 'locationId',
    label: 'locationIdOrName',
    type: 'autocomplete',
    whereOperator: '=',
    autocompleteSearch: async (queryString, cb) => {
      const locationsResponse = await locationsManagementApi.autocompleteFetch(
        'name',
        queryString,
        false,
        true
      );
      const filteredResults = locationsResponse.data.map((c) => ({
        label: c.name,
        value: c.id,
      }));
      cb(filteredResults);
    },
  },
];

export default sectorsAssociationFilters;
